<div class="page-container">
    <div class="header-container mat-elevation-z1" responsive>
        <div class="title" [class.mat-display-3]="!vp.sm" [class.mat-display-1]="vp.sm">
            Is <img class="banano-logo" responsive src="assets/bananologo.svg" /> decentralized?
        </div>
        <div class="answer" responsive [class.mat-display-1]="!vp.sm" [class.mat-h2]="vp.sm">
            <ng-container *ngIf="loading">Hang in there, counting them nanners...</ng-container>
            <ng-container *ngIf="error">See Message Below</ng-container>
            <ng-container *ngIf="!loading && !error">
                <ng-container *ngIf="nakamotoCoefficient === 1"><strong>No</strong>, not yet.</ng-container>
                <ng-container *ngIf="nakamotoCoefficient > 1"><strong>Yes</strong> it is!</ng-container>
            </ng-container>
        </div>
        <a href="https://github.com/dev-ptera" target="_blank">
            <img class="github-icon" src="assets/github-logo.svg" />
        </a>
    </div>

    <div *ngIf="error" style="margin: 72px 32px">
        <pxb-empty-state title="We've Moved!">
            <div pxb-description>
                For the latest information regarding the Banano Network, <br />check out the <a href="https://www.yellowspyglass.com/network">Yellow Spyglass</a> explorer.<br />
            </div>
            <mat-icon pxb-empty-icon>exit_to_app</mat-icon>
        </pxb-empty-state>
    </div>

    <div *ngIf="!loading && !error" class="stats-container" responsive>
        <mat-card responsive>
            <div class="mat-display-2 section-title">Distribution</div>
            <div class="mat-subheading-2 chart-subtitle">How much banano has been distributed?</div>
            <div style="display: flex; justify-content: center">
                <highcharts-chart
                    [update]="true"
                    [Highcharts]="Highcharts"
                    [options]="distributionChartOptions"
                    style="pointer-events: none"
                    [style.height.px]="vp.sm ? 140 : 200"
                    [style.width.px]="vp.sm ? 320 : vp.md ? 440 : 500"
                ></highcharts-chart>
            </div>
            <table class="distribution-table" responsive>
                <tr>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Percent</th>
                </tr>
                <tr>
                    <td>Total Supply</td>
                    <td>{{ distribution.maxSupplyTotal | appComma }}</td>
                    <td>100%</td>
                </tr>
                <tr>
                    <td>Team Banano Funds</td>
                    <td>{{ distribution.devFundTotal | appComma }}</td>
                    <td>{{ distribution.devFundPercent | appPercent }}</td>
                </tr>
                <tr>
                    <td>Circulating Supply</td>
                    <td>{{ distribution.circulatingTotal | appComma }}</td>
                    <td>{{ distribution.circulatingPercent | appPercent }}</td>
                </tr>
            </table>
            <div class="mat-subheading-1">
                <strong>{{ distribution.burnedTotal | appComma }}</strong> banano has been burned.
            </div>
        </mat-card>

        <mat-card responsive>
            <div class="mat-display-2 section-title" [style.marginBottom.px]="0">Quorum</div>
            <div class="mat-subheading-2 chart-subtitle">
                How much weight do official
                <ng-container *ngIf="!vp.sm">representatives</ng-container>
                <ng-container *ngIf="vp.sm">reps</ng-container>
                have?
            </div>
            <div style="display: flex; justify-content: center">
                <highcharts-chart
                    [update]="true"
                    [Highcharts]="Highcharts"
                    [options]="consensusChartOptions"
                    style="pointer-events: none"
                    [style.height.px]="190"
                    [style.width.px]="vp.sm ? 300 : vp.md ? 440 : 500"
                ></highcharts-chart>
            </div>

            <table class="consensus-table" responsive>
                <tr>
                    <th>Representatives</th>
                    <th>Amount</th>
                    <th>Percent</th>
                </tr>
                <tr>
                    <td>
                        Official
                        <span class="status online">[online]</span>
                    </td>
                    <td>{{ consensus.official.onlineTotal | appComma }}</td>
                    <td>{{ consensus.official.onlinePercent | appPercent }}</td>
                </tr>
                <tr>
                    <td>
                        Unofficial
                        <span class="status online">[online]</span>
                    </td>
                    <td>{{ consensus.unofficial.onlineTotal | appComma }}</td>
                    <td>{{ consensus.unofficial.onlinePercent | appPercent }}</td>
                </tr>
                <tr>
                    <td>
                        Official
                        <span class="status offline">[offline]</span>
                    </td>
                    <td>{{ consensus.official.offlineTotal | appComma }}</td>
                    <td>{{ consensus.official.offlinePercent | appPercent }}</td>
                </tr>
                <tr>
                    <td>
                        Unofficial
                        <span class="status offline">[offline]</span>
                    </td>
                    <td>{{ consensus.unofficial.offlineTotal | appComma }}</td>
                    <td>{{ consensus.unofficial.offlinePercent | appPercent }}</td>
                </tr>
                <tr>
                    <td>No Rep</td>
                    <td>{{ consensus.noRep.total | appComma }}</td>
                    <td>{{ consensus.noRep.percent | appPercent }}</td>
                </tr>
            </table>
        </mat-card>

        <mat-card responsive style="width: 100%">
            <div class="mat-display-2 section-title" [style.marginBottom.px]="0">Nakamoto Coefficient</div>
            <div class="mat-subheading-2">What is the minimum number of entities required to attack the network?</div>
            <div style="display: flex; justify-content: center; margin: 16px 0">
                <highcharts-chart
                    [update]="true"
                    [Highcharts]="Highcharts"
                    [options]="breakpointsChartOptions"
                    style="pointer-events: none"
                    [style.height.px]="vp.sm ? 200 : 300"
                    [style.width.px]="vp.sm ? 320 : 450"
                ></highcharts-chart>
            </div>
            <div class="mat-subheading-2" *ngIf="nakamotoCoefficient > 1" [style.marginTop.px]="vp.sm ? 36 : 0">
                The <strong>{{ nakamotoCoefficient }}</strong> largest entities could potentially collude together to
                achieve >50% of the online voting weight and stall the network.
            </div>
            <div class="mat-subheading-2" *ngIf="nakamotoCoefficient === 1">
                It only takes <strong>one</strong> entity to stall the network.
            </div>
            <div class="mat-subheading-1" style="margin-top: 16px">
                *Official
                <ng-container *ngIf="!vp.sm">representatives</ng-container>
                <ng-container *ngIf="vp.sm">reps</ng-container>
                are counted as a single entity. See the full representative list
                <a href="https://creeper.banano.cc/network" target="_blank">here</a>.
            </div>
        </mat-card>
    </div>
</div>
